// Utility to extract id from a value that can be a number or an object with an id property
export function getId<T extends { id: number } | number>(value: T): number {
  if (typeof value === 'object' && value !== null && 'id' in value) {
    return value.id;
  }
  return value;
}

export function toObject<T extends { id: number }>(value: T | number): T {
  if (typeof value === 'number') {
    throw new Error('Value is a number, not an object');
  }
  return value;
}

export function toObjectOrNull<T extends { id: number }>(
  value: T | number,
): T | null {
  if (typeof value === 'number') {
    return null;
  }
  return value;
}

export function isObject<T extends { id: number }>(
  value: T | number,
): value is T {
  return (
    value !== undefined &&
    typeof value === 'object' &&
    value !== null &&
    'id' in value
  );
}
